/**
 * 判断文本是否为「完整 HTML 文档」（可独立渲染）。
 * Markdown 中夹杂 HTML、或仅 ```html 代码块，不算完整 HTML。
 */
export function isCompleteHtmlDocument(text) {
  const s = String(text || '').trim();
  if (!s) return false;
  // 含 Markdown 围栏 → 视为 md，不算纯 HTML 页
  if (/```/.test(s)) return false;
  // 须以文档声明或 <html> 开头，并以 </html> 收尾
  if (/^<!DOCTYPE\s+html[\s>]/i.test(s) && /<\/html>\s*$/i.test(s)) return true;
  if (/^<html[\s>]/i.test(s) && /<\/html>\s*$/i.test(s)) return true;
  return false;
}

/**
 * 从模型输出中尽量提取纯 HTML 文档（去掉前后说明、代码围栏）。
 * 若无法提取则返回 trim 后的原文。
 */
export function extractPureHtmlDocument(text) {
  const raw = String(text || '').trim();
  if (!raw) return '';
  if (isCompleteHtmlDocument(raw)) return raw;

  const fenceRe = /```(?:html)?\s*([\s\S]*?)```/gi;
  let m;
  let best = '';
  while ((m = fenceRe.exec(raw)) !== null) {
    const code = String(m[1] || '').trim();
    if (isCompleteHtmlDocument(code) && code.length > best.length) {
      best = code;
    }
  }
  if (best) return best;

  const doctypeIdx = raw.search(/<!DOCTYPE\s+html/i);
  const htmlIdx = raw.search(/<html[\s>]/i);
  let start = -1;
  if (doctypeIdx >= 0) start = doctypeIdx;
  else if (htmlIdx >= 0) start = htmlIdx;
  if (start < 0) return raw;

  const fromStart = raw.slice(start);
  const endMatch = fromStart.match(/<\/html>/i);
  if (!endMatch) return raw;
  const extracted = fromStart.slice(0, endMatch.index + endMatch[0].length).trim();
  return isCompleteHtmlDocument(extracted) ? extracted : raw;
}
